import {
    MASTER_SkillDETAILS_REQUEST, MASTER_SkillDETAILS_FAIL, MASTER_SkillDETAILS_SUCCESS,
    MASTER_DEPARTMENT_REQUEST,MASTER_DEPARTMENT_SUCCESS,MASTER_DEPARTMENT_FAIL,
    MASTER_DESIGNATION_REQUEST,MASTER_DESIGNATION_SUCCESS,MASTER_DESIGNATION_FAIL

} from "../constants/AuthConstant";

const initialState = {
    loading: false,
    action: "Master Details Action",
    skill: [],
    department:[],
    designation:[],
    msg: "",
    error: "",
}; 

const MasterSkillReducer = (state = initialState, action) => {
    switch (action.type) {
        case MASTER_SkillDETAILS_REQUEST:
            return {
                ...state,
                loading: action.payload,
            };
        case MASTER_SkillDETAILS_SUCCESS:
            return {
                ...state,
                skill: action.result.data,
                loading: action.payload,
                msg: action.msg,
            };
        case MASTER_SkillDETAILS_FAIL:
            return {
                ...state,
                error: action.error,
                loading: action.payload,
                msg: action.msg,
            };

        case MASTER_DEPARTMENT_REQUEST:
            return {
                ...state,
                loading: action.payload,
            };
        case MASTER_DEPARTMENT_SUCCESS:
            return {
                ...state,
                department: action.result.data,
                loading: action.payload,
                msg: action.msg,
            };
        case MASTER_DEPARTMENT_FAIL:
            return {
                ...state,
                error: action.error,
                loading: action.payload,
                msg: action.msg,
            };


        case MASTER_DESIGNATION_REQUEST:
            return {
                ...state,
                loading: action.payload,
            };
        case MASTER_DESIGNATION_SUCCESS:
            return {
                ...state,
                designation: action.result.data,
                loading: action.payload,
                msg: action.msg,
            };
        case MASTER_DESIGNATION_FAIL:
            return {
                ...state,
                error: action.error,
                loading: action.payload,
                msg: action.msg,
            };

        default:
            return state;
    }
};

export default MasterSkillReducer;
